module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/AmwayIcons.ttf?5v2gxx
// module id = v2Dq
// module chunks = 0